import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=1b6d8089&scoped=true"
import script from "./Employment.vue?vue&type=script&lang=js"
export * from "./Employment.vue?vue&type=script&lang=js"
import style0 from "./Employment.vue?vue&type=style&index=0&id=1b6d8089&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d8089",
  null
  
)

export default component.exports